module.exports = __webpack_public_path__ + "img/rogue.fa71313f.png";